import React from 'react';
import PropTypes from 'prop-types';

// FSSAI non-vegetarian mark (India). Regulated colours when active; greyed when inactive (e.g. unselected filter).
const FssaiNonVegetarianIcon = ({ className, width, height, active }) => {
  const colour = active ? '#944a28' : '#bbb';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 200 200"
    >
      <rect x="25" y="25" width="150" height="150" fill="none" stroke={colour} strokeWidth="5" />
      <path d="m46.02 146.77h107.96l-53.981-93.539z" fill={colour} />
    </svg>
  );
};

FssaiNonVegetarianIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  active: PropTypes.bool,
};

FssaiNonVegetarianIcon.defaultProps = {
  height: '100%',
  width: '100%',
  active: true,
};

export default FssaiNonVegetarianIcon;
